"use client";
import { jsx as e } from "react/jsx-runtime";
import * as r from "@radix-ui/react-toggle";
import { forwardRef as i } from "react";
const g = i((o, t) => /* @__PURE__ */ e(r.Root, { "data-slot": "toggle", ...o, ref: t }));
g.displayName = "Toggle";
export {
  g as Toggle
};
